__turbopack_context__.v({
  "btn": "cgKz4G_btn",
  "btnFooter": "cgKz4G_btnFooter",
  "btnText": "cgKz4G_btnText",
  "cards": "cgKz4G_cards",
  "content": "cgKz4G_content",
  "headContact": "cgKz4G_headContact",
  "p": "cgKz4G_p",
  "page-body-wrap": "cgKz4G_page-body-wrap",
  "pagehero": "cgKz4G_pagehero",
  "paragraph": "cgKz4G_paragraph",
  "paragraph-content": "cgKz4G_paragraph-content",
  "phonecontent": "cgKz4G_phonecontent",
  "section": "cgKz4G_section",
  "store": "cgKz4G_store",
  "t": "cgKz4G_t",
  "textPink": "cgKz4G_textPink",
  "title": "cgKz4G_title",
  "wrap-container": "cgKz4G_wrap-container",
  "wrap-content": "cgKz4G_wrap-content",
});
